import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["label"]

  change(e) {
    const button = e.currentTarget
    document.querySelector("#start_date").value = button.dataset.start
    document.querySelector("#end_date").value = button.dataset.end
    document.querySelector("#start_date").closest("form").requestSubmit()
    document.body.click()
    this.labelTarget.innerText = button.innerText
  }

  connect() {
    // When the chosen dates don't match a preset, fall back to the existing
    // "Custom" option's label (the only range button without preset dates),
    // or the initial placeholder if a report has no Custom option.
    this.fallbackLabel =
      this.element.querySelector("[data-action*='income-report-dropdown#change']:not([data-start])")?.innerText.trim() ||
      this.labelTarget.innerText.trim()
    this.syncLabel = () => this.selectRangeOptionFromValues()

    this.form = this.element.closest("form")
    this.form?.addEventListener("submit", this.syncLabel)
    this.selectRangeOptionFromValues()
  }

  disconnect() {
    this.form?.removeEventListener("submit", this.syncLabel)
  }

  selectRangeOptionFromValues() {
    const start = document.querySelector("#start_date").value
    const end = document.querySelector("#end_date").value
    const button = document.querySelector(`[data-start='${start}'][data-end='${end}']`)
    this.labelTarget.innerText = button ? button.innerText.trim() : this.fallbackLabel
  }
}
